// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__r8H4Z","productName":"Table_productName__2g_wp"};